import { FUEL_TYPES, CONSUMPTION_CONFIG } from 'config/app-config';

export const getEnergyUsage = (
  consumptionType,
  selectedFuelType,
  isTwoRate
) => {
  const gasUsage = CONSUMPTION_CONFIG[FUEL_TYPES.GAS][consumptionType];
  const electricityUsage = isTwoRate
    ? CONSUMPTION_CONFIG.economy7[consumptionType]
    : CONSUMPTION_CONFIG[FUEL_TYPES.ELECTRIC][consumptionType];

  return {
    ...(selectedFuelType[FUEL_TYPES.GAS] ? { [FUEL_TYPES.GAS]: gasUsage } : {}),
    ...(selectedFuelType[FUEL_TYPES.ELECTRIC]
      ? { [FUEL_TYPES.ELECTRIC]: electricityUsage }
      : {})
  };
};
